import LocalStorage from '../defined/localStorage';
import Utils from '../utils';
import { logoutReducer } from '../mobile/modules/Auth/Slice/authSlice';
import { successUserDetailReducer } from '../mobile/modules/UserProfile/Slice/userProfileSlice';

/**
 * Reusable logout cleanup function.
 *
 * @param {object}   options
 * @param {function} [options.dispatch]       - Redux dispatch (store.dispatch or useDispatch)
 * @param {function} [options.navigate]       - Router navigate function
 * @param {string}   [options.endpointType]   - 'userMobileEndpoints' | 'dealerTechnicianEndpoints'
 * @param {function} [options.logoutAction]   - Web-dashboard logout thunk (UserAction.logoutAction)
 * @param {string}   [options.redirectUrl]    - Custom redirect URL (overrides endpointType-based route)
 */
export const logoutCleanup = ({
    dispatch,
    navigate,
    endpointType,
    logoutAction,
    redirectUrl,
} = {}) => {
    LocalStorage.clear();

    try {
        if (window.zE) {
            window.zE('messenger', 'logoutUser');
            window.zE('messenger', 'hide');
        }
    } catch (e) {
        // Zendesk widget may not be loaded
    }

    if (dispatch) {
        if (logoutAction) {
            dispatch(logoutAction());
        } else {
            dispatch(successUserDetailReducer({ data: null }));
            dispatch(logoutReducer());
        }
    }

    if (redirectUrl) {
        navigate ? navigate(redirectUrl) : (window.location.href = redirectUrl);
    } else if (navigate && endpointType) {
        navigate(Utils.EndPoint[endpointType].auth);
    }
};
